import { CollapseComponent } from "@opten/collapse";
import { factory } from "@opten/compiler/factory";
import { CourseComponent } from "./components/active-city/course";
import { NavbarComponent } from "./components/active-city/navbar";
import { MapFilterComponent } from "./components/zaemegolaufe/map-filter";
import { AlertComponent } from "./components/shared/alert";
import { DatepickerComponent } from "./components/shared/datepicker";
import { FormCheckboxesComponent } from "./components/shared/form-checkboxes";
import { FormSelectUpdateComponent } from "./components/shared/form-select-updater";
import { FormTemplatesComponent } from "./components/shared/form-templates";
import { FormTotalComponent } from "./components/shared/form-total";
import { HeadlineSliderComponent } from "./components/shared/headline-slider";
import { GlobalVarsComponent } from "./components/shared/globalvars";
import { GridComponent } from "./components/shared/grid";
import { InputComponent } from "./components/shared/input";
import { MapComponent } from "./components/shared/map";
import { MediaSliderComponent } from "./components/shared/media-slider";
import { ModalComponent } from "./components/shared/modal";
import { PageTopComponent } from "./components/shared/page-top";
import { PasswordRevealComponent } from "./components/shared/password-reveal";
import { ReCaptchaComponent } from "./components/shared/recaptcha";
import { ScrollToComponent } from "./components/shared/scroll-to";
import { PaginationComponent } from "./components/zaemegolaufe/pagination";

const initialize = factory([
	CollapseComponent,
	NavbarComponent,
	HeadlineSliderComponent,
	ScrollToComponent,
	MediaSliderComponent,
	MapComponent,
	MapFilterComponent,
	InputComponent,
	PasswordRevealComponent,
	DatepickerComponent,
	CourseComponent,
	ReCaptchaComponent,
	PageTopComponent,
	ModalComponent,
	GridComponent,
	FormTotalComponent,
	FormTemplatesComponent,
	FormCheckboxesComponent,
	FormSelectUpdateComponent,
	AlertComponent,
	PaginationComponent,
]);

initialize(document.body);

FormTemplatesComponent.onFieldAdded.subscribe((container) => {
	initialize(container);
});

const vars = new GlobalVarsComponent();
